export const loadYotpoScript = (src) => {
    if (document.querySelector(`script[src="${src}"]`)) {
        console.log('Yotpo script already loaded');
        return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    document.head.appendChild(script);
};
